import Stickyfill from "stickyfilljs";

export default function sticky() {
    const ELEMENTS = document.querySelectorAll('.sticky');
    ELEMENTS.length > 0 && Stickyfill.add(ELEMENTS);
}
